module.exports = __webpack_public_path__ + "img/Trustpilot_ratings_5star-RGB.cb9d2c37.svg";